import { render } from "./User_Details.vue?vue&type=template&id=26c1fdb6"
import script from "./User_Details.vue?vue&type=script&lang=js"
export * from "./User_Details.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__